module.exports = __webpack_public_path__ + "images/emoji/sunny.df8aebab8e983c861842.png";